import { createContext, useState } from 'react';

interface SelectedPlatformsContextProps {
  selectedPlatformsIds: number[];
  setSelectedPlatformsIds: (selectedPlatforms: number[]) => void;
  selectedPlatformsName?: string[];
  setSelectedPlatformsName?: (selectedPlatforms: string[]) => void;
}

const SelectedPlatformsContext = createContext<SelectedPlatformsContextProps>({
  selectedPlatformsIds: [],
  setSelectedPlatformsIds: () => {},
  selectedPlatformsName: [],
  setSelectedPlatformsName: () => {}
});

const SelectedPlatformsProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedPlatformsIds, setSelectedPlatformsIds] = useState<number[]>([]);
  const [selectedPlatformsName, setSelectedPlatformsName] = useState<string[]>([]);

  return (
    <SelectedPlatformsContext.Provider value={{ selectedPlatformsIds, setSelectedPlatformsIds, selectedPlatformsName, setSelectedPlatformsName}}>
      {children}
    </SelectedPlatformsContext.Provider>
  );
};

export { SelectedPlatformsProvider, SelectedPlatformsContext };